import { useQuery } from 'react-query';
import { StockAllocationsService, StockAllocation, StockFeedError } from '../services/stockAllocationsService';

interface UseStockAllocationsResult {
  allocations: StockAllocation[] | undefined;
  allocationsMap: Map<string, StockAllocation[]> | undefined;
  error: StockFeedError | null;
  isLoading: boolean;
  refetch: () => void;
}

export function useStockAllocations(enabled = true): UseStockAllocationsResult {
  const { data, error, isLoading, refetch } = useQuery(
    ['stock-allocations'],
    async () => {
      const result = await StockAllocationsService.fetchAllocations(true);
      if (result.error) throw result.error;
      return result.data;
    },
    {
      enabled,
      staleTime: 60_000,
      retry: false,
    }
  );

  const allocationsMap = data ? StockAllocationsService.groupByContract(data) : undefined;

  return {
    allocations: data || undefined,
    allocationsMap,
    error: error as StockFeedError | null,
    isLoading,
    refetch,
  };
}
